module.exports = __webpack_public_path__ + "media/svg/cr-fcd130ef.svg";